export default __webpack_public_path__ + "static/media/Five.3e9884b4.png";